<div
  class="card"
  *appIsGranted="['PACKETS_SETUP_ATIVACAO', 'PACKETS_SETUP_ATIVACAO', 'READ']"
>
  <div class="card-body column">
    <div class="row">
      <h6 class="card">Setup de Ativação</h6>
      <div class="col-md-10">
        <label>Serial</label>
        <input class="w-100" placeholder="205502151" [(ngModel)]="seriais" />
      </div>
      <div class="col-md-2">
        <div class="row w-75 ms-4">
          <button
            type="button"
            class="btn btn-primary btn-sm"
            (click)="searchSetup()"
          >
            Pesquisar
          </button>
        </div>
      </div>
      <div class="col-md-2 d-inline">
        <input
          class="form-check-input ms-2"
          type="radio"
          name="formRadios"
          id="formRadios1"
          value="0"
          [(ngModel)]="prettyEvent"
          checked
        />
        <label class="form-check-label" for="formRadios1"> 0 </label>
        <input
          class="form-check-input ms-2"
          type="radio"
          name="formRadios"
          id="formRadios2"
          value="1"
          [(ngModel)]="prettyEvent"
        />
        <label class="form-check-label" for="formRadios2"> 1 </label>
        <input
          class="form-check-input ms-2"
          type="radio"
          name="formRadios"
          id="formRadios3"
          value="2"
          [(ngModel)]="prettyEvent"
        />
        <label class="form-check-label" for="formRadios2"> 2 </label>
      </div>
    </div>
  </div>
</div>
<div class="card">
  <div class="card align-items-center" *ngIf="circularProgressiveWait">
    <div card="card-body">
      <div class="spinner-border text-primary m-1" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
  <div class="card overflow-auto">
    <div class="card-body">
      <table class="table table-fit table-bordered table-hover">
        <thead class="table-primary">
          <tr>
            <th class="text-center" scope="col-md-2">Serial</th>
            <th class="text-center" scope="col-md-10">Setup</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of setup; let i = index">
            <td class="text-center" scope="row">{{ item.serial }}</td>
            <td class="" scope="row">
              <div>
                <div *ngIf="prettyEvent == '0'">
                  <ngx-json-viewer
                    [json]="item.setup"
                    [depth]="4"
                  ></ngx-json-viewer>
                </div>

                <div *ngIf="prettyEvent == '1'">
                  <ngx-json-viewer
                    [json]="item.setup"
                    [depth]="1"
                    [expanded]="true"
                  ></ngx-json-viewer>
                </div>
                <div *ngIf="prettyEvent == '2'">
                  <p [innerHTML]="item.setup | json"></p>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
